import React from "react";
import { NavLink } from "react-router-dom";
import classnames from "classnames";
import { Text } from "components/commons";
import styles from "./tab-bar.module.scss";

const TabBar = ({ className, items, activeTab, onTabChange }) => {
  return (
    <div className={classnames("flex items-baseline", className)}>
      {items.map((item, i) => {
        // If no routing (onTabChange provided), render as button for content switching
        if (onTabChange) {
          const isActive = activeTab === item.id;
          return (
            <button
              key={i}
              onClick={() => onTabChange(item.id)}
              className={classnames("mr-lg py-sm", styles.navLink, {
                [styles.active]: isActive,
              })}
              style={{
                background: "none",
                borderTop: "none",
                borderLeft: "none",
                borderRight: "none",
                cursor: "pointer",
                padding: "inherit",
                borderBottom: isActive ? "2px solid #1c4f5a" : "none",
              }}
            >
              <Text size="text-md" color="text-inherit" strong>
                {item.text}
              </Text>
            </button>
          );
        }

        // Original NavLink behavior for path-based navigation
        return (
          <NavLink
            key={i}
            activeClassName={classnames(styles.active)}
            className={classnames("mr-lg py-sm", styles.navLink)}
            to={item.to}
            exact
          >
            <Text size="text-md" color="text-inherit" strong>
              {item.text}
            </Text>
          </NavLink>
        );
      })}
    </div>
  );
};

export default TabBar;
